import React, { useEffect, useState } from "react";
import { FormatMoney } from "../../../Helpers/FormatNumber";

export const AnticiposMultiplesNotasSection = ({ data }) => {
  const [registros, setRegistros] = useState([]);

  useEffect(() => {
    setRegistros(data ?? []);
  }, [data]);

  return (
    <div className="listado-fiscal-invoicemovimientos-container">
      <div className="listado-fiscal-invoicemovimientos-container-tabla scroll">
        <table>
          <thead>
            <tr>
              <th colSpan={13}>Clientes con cargos superiores a abonos </th>
            </tr>
            <tr>
              <th>Referencia</th>
              <th><div>Total Cargos</div></th>
              <th><div>Total Abonos</div></th>
              <th><div>Saldo</div></th>
              <th><div>Movimiento</div></th>
              <th><div>Fecha </div></th>
              <th><div>Batch</div></th>
              <th><div>Cargo</div></th>
              <th><div>Abono</div></th>
              <th><div>Descripción</div></th>
              <th><div>Relacionado</div></th>
              <th><div>Fecha Relacionada</div></th>
              <th><div>Usuario</div></th>
            </tr>
          </thead>
          <tbody>
            {registros.map((reg, i) => (
              <tr key={i}>
                <td className="ta-center">{reg.v_ref}</td>
                <td className="ta-right">{FormatMoney(reg.total_cargos)}</td>
                <td className="ta-right">{FormatMoney(reg.total_abonos)}</td>
                <td className="ta-right">{FormatMoney(reg.saldo)}</td>
                <td className="ta-center">{reg.movimiento}</td>
                <td className="ta-center">
                  {reg.fecha_mov
                    ? new Date(reg.fecha_mov).toLocaleDateString("es-MX", {
                        day:   "2-digit",
                        month: "2-digit",
                        year:  "numeric",
                      })
                    : "-"}
                </td>
                <td className="ta-center">{reg.batch_mov}</td>
                <td className="ta-right">{FormatMoney(reg.cargo_mov)}</td>
                <td className="ta-right">{FormatMoney(reg.abono_mov)}</td>
                <td className="ta-left">{reg.descripcion}</td>
                <td className="ta-center">{reg.relacionado}</td>
                <td className="ta-center">{reg.v_fecha_relacion
                    ? new Date(reg.v_fecha_relacion).toLocaleDateString("es-MX", {
                        day:   "2-digit",
                        month: "2-digit",
                        year:  "numeric",
                      })
                    : "-"}</td>
                <td className="ta-center">{reg.usuario}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
